import React, { useEffect, useState } from 'react';
import { Select, InputNumber, Button, Form, Space, message, Tooltip, Row, Col, Flex, Modal, Input, Divider, DatePicker, Typography, Tag, Descriptions, Table } from 'antd';
import AuthService from '../../Components/auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { showMessage } from '../../Components/Utils/message';
import { ArrowLeftOutlined, CodeSandboxOutlined, DeleteFilled, DeleteOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { decodeId, encodeId, extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from '../../Components/common/CommonFun';
import { Button as UploadButton, IconButton, styled } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { env, wms_uploads_cdn } from '../../Components/config';
import dayjs from 'dayjs';
import ProductScanSelect from '../Scan/ProductScanSelect';
import { fetchLocationBatches, fetchLocations, fetchLocationStockByProduct, fetchProducts } from '../../Services/StocksApiService';
import ScanSelect from '../Scan/ScanSelect';
import DetailsGrid from '../../Components/common/DetailsGrid';
const Auth = new AuthService();
const DataSheet = styled('div')`
   .ant-input-number-disabled {
      background: none;
      color: black;
    }
    .ant-picker-outlined.ant-picker-disabled {
        background: white;
        color: black;
    }
    .ant-picker-outlined.ant-picker-disabled  .ant-picker-input > input {
        color: black;
    }
`;

const InventoryAdjustment = () => {
    const params = useParams();
    const decodedID = decodeId(params?.id)
    const { TextArea } = Input;
    const { Option } = Select;
    const { Text } = Typography;
    const navigate = useNavigate()
    const layoutDispatch = useLoadingDispatch()
    const [products, setProducts] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedProductLocations, setSelectedProductLocations] = useState([]);
    const [locationsBatches, setLocationBatches] = useState([]);
    const [itemDetails, setItemDetails] = useState({
        product_id: null,
        item_code: null,
        location_id: null,
        quantity: "",
        batch_id: null,
        batch_code: null,
        supplier_batch_code: null,
        batch_expiry: null,
        batch_quantity: null,
    });
    const [modalVisible, setModalVisible] = useState(false);
    const [notes, setNotes] = useState("");
    const [date, setDate] = useState(dayjs());
    const [posted, setPosted] = useState(false);
    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = React.useState([]);
    const [adjustmentDetails, setAdjustmentDetails] = useState({ cycle_count_code: 'CC-000' });
    const [id, setId] = React.useState(decodedID ? decodedID : 0);
    const [adjustmentsData, setAdjustmentsData] = useState([
    ]);

    const getAllPro = async () => {
        showLoading(layoutDispatch)
        try {
            const res = await fetchProducts();
            if (res.ack) {
                if (res?.products.length > 0) {
                    setProducts(res?.products)
                    return true;

                } else {
                    showMessage("error", res.message);
                    setProducts([])
                    return false;

                }
            }
        } catch (error) {
            console.log(error);
            showMessage("error", "Something went wrong while fetching products.");
            return false;

        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const getAllLoc = async () => {
        showLoading(layoutDispatch)
        try {
            const res = await fetchLocations();
            if (res.ack) {
                if (res?.locations.length > 0) {
                    setLocations(res?.locations)
                    return true;

                } else {
                    showMessage("error", res.message);
                    setLocations([])
                    return false;

                }
            }
        } catch (error) {
            console.log(error);
            showMessage("error", "Something went wrong while fetching products.");
            return false;

        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const fetchAdjustmentById = async (adjustmentId) => {
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/stock/inventory-adjustment?id=${adjustmentId}`);
            if (res.ack) {
                setAdjustmentsData(res?.wms_inventory_adjustment_items ? res?.wms_inventory_adjustment_items : []);
                setDate(res?.inventory_adjustment.posting_date ? dayjs(res?.inventory_adjustment.posting_date, 'YYYY-MM-DD') : null)
                setNotes(res?.inventory_adjustment?.notes)
                setCurrentItemFiles(res?.inventory_adjustment?.files ? JSON.parse(res?.inventory_adjustment?.files) : [])
                setPosted(res?.inventory_adjustment?.posted_by > 0 ? true : false)
                setAdjustmentDetails(res?.inventory_adjustment);

            } else {
                showMessage('error', res.message);
            }
        } catch (err) {
            console.error(err);
            showMessage('error', 'Failed to fetch adjustment data.');

        } finally {
            hideLoading(layoutDispatch);
        }
    };

    useEffect(() => {
        const init = async () => {
            const proSuccess = await getAllPro();
            const LocSuccess = await getAllLoc();
            if (LocSuccess && proSuccess && id && Number(id) > 0) {
                await fetchAdjustmentById(Number(id));
            }
        };

        init();
    }, []);

    const getLocationsByProduct = async (product) => {
        showLoading(layoutDispatch);
        try {
            const res = await fetchLocationStockByProduct(product)
            if (res?.ack) {
                const resLocations = res?.product_location || [];

                const matchedLocations = locations
                    ?.map(loc => {
                        const matchedRes = resLocations.find(r => r.location_id === loc.id);
                        if (matchedRes) {
                            return {
                                ...loc,
                                quantity: matchedRes.quantity || 0, // push quantity from response
                            };
                        }
                        return null;
                    })
                    .filter(Boolean) // remove unmatched
                    .sort((a, b) => (b.is_picking || 0) - (a.is_picking || 0)); // sort by is_picking

                setSelectedProductLocations(matchedLocations || []);
            } else {
                setSelectedProductLocations([]);
                showMessage('error', res?.message)
            }
        } catch (err) {
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }

    };

    const getProductLocationBatches = async (payload) => {
        showLoading(layoutDispatch);
        try {
            const res = await fetchLocationBatches(payload)
            if (res?.ack) {
                setLocationBatches(res.location_batches);
            } else {
                setLocationBatches([]);
                showMessage('error', res?.message)
            }
        } catch (err) {
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }

    };

    const handleProductChange = (value, isScan = false) => {

        const selectedProduct = isScan
            ? products?.find((pro) => pro?.code === value || pro?.barcode === value)
            : products?.find((pro) => pro?.netsuite_id === value);

        setItemDetails({
            ...itemDetails,
            product_id: selectedProduct?.netsuite_id,
            item_code: selectedProduct?.code,
            location_id: null,
            quantity: "",
            batch_id: null,
            batch_code: null,
            supplier_batch_code: null,
            batch_expiry: null,
            batch_quantity: null,
        })
        getLocationsByProduct(selectedProduct?.netsuite_id)
    };

    const handleLocationChange = (value, isScan = false) => {
        const selectedLocation = isScan
            ? selectedProductLocations?.find((loc) => loc?.code === value)
            : selectedProductLocations?.find((loc) => loc?.id === value);

        setItemDetails({ ...itemDetails, location_id: selectedLocation?.id, batch_id: null, batch_code: null, batch_quantity: null, batch_expiry: null, supplier_batch_code: null });

        const batchPayload = {
            location: selectedLocation?.id,
            product: itemDetails?.product_id
        }
        getProductLocationBatches(batchPayload)
    }

    console.log('adjustmentData', adjustmentsData);

    const addProduct = () => {
        setModalVisible(true)
    };

    const handleSave = async () => {

        if (!date) return showMessage('error', 'Please select a posting date.');
        const updatedItems = adjustmentsData?.map(item => {
            const matchedProduct = products?.find(
                (pro) => pro?.netsuite_id === item?.product_netsuite_id
            );

            return {
                ...item,
                item_code: matchedProduct?.code || null,
            };
        })
        const dataToSend = {
            files: currentItemFiles,
            notes: notes,
            posting_date: dayjs(date).format('YYYY-MM-DD'),
            wms_inventory_adjustment_items: updatedItems
        }
        if (id > 0) dataToSend.id = id
        try {
            const res = await Auth.fetch('/stock/inventory-adjustment', {
                method: id > 0 ? 'PUT' : 'POST',
                body: JSON.stringify(dataToSend)
            })
            if (res?.ack) {
                showMessage('success', res?.message)
                const recordID = id > 0 ? id : res?.record_id;
                const uploadPromises = []
                if (files.length > 0) {
                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'stock-adjustment', recordID)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                navigate('/transaction-inventory')

            } else {
                if (res?.errors?.length > 0) {
                    const allErrors = res.errors.join('\n');
                    showMessage('error', allErrors);
                } else {
                    showMessage('error', res?.message)
                }
            }
        } catch (err) {
            showMessage('error', 'something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const postAdjustment = async () => {
        if (!date) return showMessage('error', 'Please select a posting date.');
        const updatedItems = adjustmentsData?.map(item => {
            const matchedProduct = products?.find(
                (pro) => pro?.netsuite_id === item?.product_netsuite_id
            );

            return {
                ...item,
                item_code: matchedProduct?.code || null,
            };
        })
        const dataToSend = {
            files: currentItemFiles,
            notes: notes,
            posting_date: dayjs(date).format('YYYY-MM-DD'),
            wms_inventory_adjustment_items: updatedItems
        }
        if (id > 0) dataToSend.id = id
        showLoading(layoutDispatch)
        try {
            const res = await Auth.fetch('/stock/inventory-adjustment', {
                method: id > 0 ? 'PUT' : 'POST',
                body: JSON.stringify(dataToSend)
            })
            if (res?.ack) {
                const recordID = id > 0 ? id : res?.record_id;
                const uploadPromises = []
                if (files.length > 0) {
                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'stock-adjustment', recordID)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                const PostData = {
                    id: recordID,
                }
                try {
                    const postRes = await Auth.fetch(`/stock/post-inventory-adjustment`, {
                        method: 'POST',
                        body: JSON.stringify(PostData)
                    });

                    if (postRes?.ack) {
                        showMessage('success', postRes.message || 'Adjustment posted successfully.');
                        setTimeout(() => {
                            navigate('/transaction-inventory')
                        }, 1000);
                    } else {
                        showMessage('error', postRes.message || 'Failed to post adjustment.');
                    }

                } catch (postError) {
                    console.error(postError);
                    showMessage('error', 'Something went wrong while posting the adjustment.');
                }
            } else {
                 if (res?.errors?.length > 0) {
                    const allErrors = res.errors.join('\n');
                    showMessage('error', allErrors);
                } else {
                    showMessage('error', res?.message)
                }
            }
        } catch (err) {
            showMessage('error', 'something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    };

    const submitImage = (e) => {
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }

    const handleModalCancel = () => {
        setItemDetails({
            product_id: null,
            item_code: null,
            location_id: null,
            quantity: "",
            batch_id: null,
            batch_code: null,
            supplier_batch_code: null,
            batch_expiry: null,
            batch_quantity: null,
        })
        setModalVisible(false);
        setLocationBatches([]);
        setSelectedProductLocations([])
    };

    const handleModalOk = async () => {
        if (!itemDetails?.product_id || !itemDetails?.location_id || !itemDetails?.batch_id) {
            showMessage('error', 'Fill all fields to proceed')
            return;
        }
        // if (itemDetails.quantity === "" || itemDetails.quantity === null || itemDetails.quantity === undefined) return showMessage('error', "Quantity must be filled in before proceeding!");
        // const isDuplicate = adjustmentsData.some(
        //     (item) => item.batch_code === itemDetails.batch_code
        // );

        // if (isDuplicate) return showMessage('error', 'Duplicate batch — this batch is already added')
        const dataToAdd = {
            product_netsuite_id: itemDetails?.product_id,
            location_id: itemDetails?.location_id,
            batch_code: itemDetails?.batch_code,
            supplier_batch_code: itemDetails?.supplier_batch_code,
            expiry_date: itemDetails?.batch_expiry,
            quantity: itemDetails?.quantity,
            purchase_order_details_batch_id: itemDetails?.batch_id,
            // item_code: itemDetails?.item_code,
            current_quantity: itemDetails?.batch_quantity,
        }

        adjustmentsData.push(dataToAdd)

        setItemDetails({ product_id: '', item_code: null, location_id: null, quantity: "", batch_code: null, batch_expiry: null, batch_quantity: null, batch_id: null })
        setModalVisible(false);
        setLocationBatches([])
        setSelectedProductLocations([]);
        showMessage('success', 'Inventory adjustment item added')
    };

    const handleDelete = (index) => {
        Modal.confirm({
            title: "Are you sure you want to delete this item?",
            okText: 'DELETE',
            okButtonProps: { danger: true },
            onOk: () => {
                const updated = [...adjustmentsData];
                updated.splice(index, 1);
                setAdjustmentsData(updated);
            },
        });
    };

    const dataCol = [
        {
            title: 'Product',
            render: (record) => {
                if (record?.product_netsuite_id) {
                    const product = products?.find(obj => obj.netsuite_id == record?.product_netsuite_id);
                    if (product) {
                        return `${product?.code} - ${product?.name} `;
                    }
                }
                return '';
            }
        },
        {
            title: 'Location',
            render: (record) => {
                const selected = locations?.find((item) => item.id == record?.location_id)
                return (
                    <>
                        {selected?.code || ''}
                    </>
                );
            }
        },


        {
            title: 'Batch Code',
            render: (record) => {
                return (
                    <>
                        {`${record?.batch_code || ''} `}
                    </>
                );
            }
        },

        {
            title: 'Supplier Batch Code',
            render: (record) => {
                return (
                    <>
                        {`${record?.supplier_batch_code || ''} `}
                    </>
                );
            }
        },
        {
              title: "Expiry Date",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{dayjs(expiry).format('DD-MM-YYYY')}</Tag>;
              }
            },

        {
            title: 'Quantity',
            render: (text, record) => {
                const formattedStock = Number(record?.quantity).toLocaleString();
                return (
                    <Tag color={record?.quantity > 0 ? 'green' : 'red'} style={{ fontSize: 16, fontWeight: 'bold' }}>{formattedStock}</Tag>

                );
            }
        },
        // {
        //     title: "Action",
        //     render: (_, __, index) => (
        //         <DeleteFilled style={
        //             {
        //                 fontSize: "25px",
        //                 cursor: "pointer",
        //                 color: "#cd1437",
        //             }} onClick={() => handleDelete(index)} />
        //     ),
        // }

    ]

    if (!posted && !adjustmentDetails?.wms_cycle_count_id && !adjustmentDetails?.route_status_id) {
        dataCol.push({
            title: "Action",
            align: 'center',
            render: (_, __, index) => (
                <DeleteFilled style={
                    {
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#cd1437",
                    }} onClick={() => handleDelete(index)} />
            ),
        })
    }

    const infoItems = [
        {
          label: 'Adjustment Code',
          value: adjustmentDetails?.wms_inventory_adjustment_code || 'N/A',
          icon: <CodeSandboxOutlined style={{ color: "#52c41a" }} />,
          type: 'text',
        },
        // {
        //   label: 'Posting Date',
        //   value: recievedData[0]?.posting_date
        //     ? dayjs(recievedData[0]?.posting_date).format('DD-MM-YYYY')
        //     : '-',
        //   icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
        //   type: 'text',
        // }
      ]

    return (
        <DataSheet>
            <Flex justify='space-between' align='center' style={{ marginBottom: '20px' }}>
                <h3 style={{ margin: 0 }}>Inventory Adjustment</h3>
                <Flex align='center'>

                    {adjustmentDetails?.wms_cycle_count_code && adjustmentDetails?.wms_cycle_count_id && (
                        <Tag
                            color="white"

                            style={{
                                padding: '2px 6px',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                // cursor: 'pointer',
                                backgroundColor: '#e6f4ff',
                                border: '1px solidrgb(207, 216, 221)',
                                borderRadius: '6px',
                                color: '#084c8b',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <span style={{ fontWeight: 500 }}>Cycle Count:</span>
                            <span
                                onClick={() => {
                                    if (adjustmentDetails?.wms_cycle_count_id) {

                                        const hasedID = encodeId(adjustmentDetails?.wms_cycle_count_id)
                                        navigate(`/cycle-counts/update/${hasedID}`);
                                    }

                                    else
                                        showMessage('info', 'No adjustment created for this cycle count');
                                }}
                                style={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                    background: '#dbeafe',
                                    color: '#1d4ed8',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                            >
                                {adjustmentDetails?.wms_cycle_count_code || 'N/A'}
                            </span>
                        </Tag>
                    )}
                    { adjustmentDetails?.route_status_id && (
                        <Tag
                            color="white"

                            style={{
                                padding: '3px 6px',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                // cursor: 'pointer',
                                backgroundColor: '#e6f4ff',
                                border: '1px solidrgb(207, 216, 221)',
                                borderRadius: '6px',
                                color: '#084c8b',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <span style={{ fontWeight: 500 }}>Missed Picking:</span>
                            <span
                                style={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                    background: '#dbeafe',
                                    color: '#1d4ed8',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    textDecoration: 'underline',
                                }}
                            >
                                {adjustmentDetails?.route_code ? `${adjustmentDetails?.route_name} (${adjustmentDetails?.route_code})` : 'N/A'}
                            </span>
                        </Tag>
                    )}
                    { adjustmentDetails?.route_delivery_date && (
                        <Tag
                            color="white"

                            style={{
                                padding: '2px 6px',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                // cursor: 'pointer',
                                backgroundColor: '#e6f4ff',
                                border: '1px solidrgb(207, 216, 221)',
                                borderRadius: '6px',
                                color: '#084c8b',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <span style={{ fontWeight: 500 }}>Delivery Date:</span>
                            <span
                                style={{
                                    fontFamily: 'monospace',
                                    fontWeight: 'bold',
                                    background: '#dbeafe',
                                    color: '#1d4ed8',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                            >
                                {adjustmentDetails?.route_delivery_date ? dayjs(adjustmentDetails?.route_delivery_date).format('DD-MM-YYYY') : 'N/A'}
                            </span>
                        </Tag>
                    )}
                    { posted && (
                        <Tag
                            color="red"
                            style={{
                                fontSize: '17px',
                                fontWeight: 'bold',
                                padding: '4px 4px',
                            }}
                        >
                            Posted
                        </Tag>
                    )}
                    <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/transaction-inventory')}>Back</Button>

                </Flex>

            </Flex>
            {
                adjustmentDetails?.wms_inventory_adjustment_code && (
                    // <Descriptions style={{ marginBottom: "5px", marginTop: 10 }} bordered size={"small"}>
                    //     <Descriptions.Item
                    //         label={`Adjustment Code`}
                    //         labelStyle={{ width: "200px" }}
                    //     >
                    //         <Text code>{adjustmentDetails?.wms_inventory_adjustment_code || 'N/A'} </Text>
                    //     </Descriptions.Item>
                    // </Descriptions>
                    <DetailsGrid infoItems={infoItems} />
                )
            }
            <Row gutter={16} style={{ marginTop: "10px" }}>
                <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                    <Text>Posting Date<span style={{ color: 'red' }}>*</span></Text>
                    <br />
                    <DatePicker
                        format={'DD-MM-YYYY'}
                        style={{ width: '100%' }}
                        size="large"
                        value={date}
                        onChange={(date) => {
                            if (date) setDate(dayjs(date, 'YYYY-MM-DD'));
                            else setDate(null);
                        }}
                        placeholder="Adjustment Date"
                        disabled={posted}
                        disabledDate={(current) => {
                            return current && current < dayjs().startOf('day')
                        }}

                    />
                </Col>
                <Col xs={24} sm={12} md={16} lg={16} xl={16}>
                    <Text>
                        Notes:
                    </Text>
                    <br />
                    <TextArea
                        value={notes}
                        size='large'
                        onChange={(e) => { setNotes(e.target.value) }}
                        placeholder='Notes.'
                        autoSize={{ minRows: 1, maxRows: 6 }}
                        style={{
                            width: '100%',
                        }}
                        disabled={posted}
                    />

                </Col>
            </Row>
            <>
                <div>
                    <UploadButton
                        disabled={posted}
                        component="label"
                        variant="contained"
                        sx={{ marginTop: "10px" }}
                        startIcon={<CloudUploadIcon />}
                    >
                        Add files
                        <input
                            type="file"
                            hidden
                            multiple
                            capture
                            onClick={(e) => {
                                // ensures it always triggers even if same file is picked
                                e.target.value = "";
                            }}
                            onChange={(e) => {
                                const myfiles = e.target.files;

                                if (myfiles.length > 10) {
                                    showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                    e.target.value = "";
                                } else {
                                    submitImage(e);
                                }
                            }}
                        />
                    </UploadButton>
                </div>

                {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
                <ul>
                    {currentItemFiles?.length > 0 &&
                        currentItemFiles
                            .filter(
                                (item) =>
                                    !files.some((file) => file.name === item)
                            )
                            .map((item) => {
                                const encodedFileName = item.replace(/\+/g, '%2B');
                                return (
                                    <li>
                                        <IconButton
                                            disabled={posted}
                                            aria-label="delete"
                                            color="primary"
                                            onClick={() => handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles,)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>

                                        <a
                                            href={`${wms_uploads_cdn}/${env}/stock-adjustment/${id}/${encodedFileName}`}
                                            target="_blank"
                                        >
                                            {extractOriginalFileName(encodedFileName)}
                                        </a>
                                    </li>
                                );
                            })}
                </ul>

                {files?.length > 0 && <Divider />}

                {files?.length > 0 && <h4>Files:</h4>}
                <ul>
                    {files.length > 0 &&
                        files.map((file) => {
                            const encodedFileName = file?.name.replace(/\+/g, '%2B');
                            return (
                                <li>
                                    {" "}
                                    <IconButton
                                        disabled={posted}
                                        aria-label="delete"
                                        color="primary"
                                        onClick={() => handleDeleteFile(file.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                    {extractOriginalFileName(encodedFileName)}
                                </li>
                            );
                        })}
                </ul>
            </>
            <Divider />
            {
                !posted && (
                    <>
                        {
                            (!adjustmentDetails?.wms_cycle_count_id && !adjustmentDetails?.route_status_id) && (
                                <Button onClick={addProduct} type="dashed" style={{ marginBottom: 16 }}>
                                    + Add Products
                                </Button>
                            )
                        }

                    </>
                )
            }
            <br />
            <>
                {adjustmentsData?.length > 0 && (
                    <>
                        <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Adjustment Items</Text>
                        <Table
                            dataSource={adjustmentsData}
                            columns={dataCol}
                            pagination={false}
                            scroll={{ x: 'max-contnet' }}
                        />
                    </>
                )}

            </>

            {
                (!posted && adjustmentsData?.length > 0) && (
                    <Flex justify='end' gap={5} style={{ marginTop: 10 }}>
                        <Button type='primary' onClick={handleSave}>Save</Button>
                        <Button danger onClick={() => {
                            Modal.confirm({
                                title: "Are you sure you want to post this adjustment?",
                                okText: 'POST',
                                okButtonProps: { danger: true },
                                onOk: () => postAdjustment(),
                            });
                        }}
                        >Post</Button>
                    </Flex>
                )
            }



            <Modal
                width={'70VW'}
                title={`Inventory Adjustment Item`}
                open={modalVisible}
                onCancel={handleModalCancel}
                onOk={handleModalOk}
                okText='Save'
            >
                <Divider style={{ margin: '2px 2px' }} />
                <>
                    <Row style={{ marginBottom: "10px" }}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <Text>Product</Text>
                            <ProductScanSelect onValueChange={handleProductChange} value={itemDetails?.product_id} options={products} placeholder="Product" size="large" length={'100%'} />
                        </Col>
                    </Row>
                    {
                        itemDetails?.product_id && (
                            <Row style={{ marginBottom: "10px" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Text>Location</Text>
                                    <ScanSelect onValueChange={handleLocationChange} value={itemDetails?.location_id} options={selectedProductLocations} placeholder="Location" size="large" length={'100%'} />
                                </Col>
                            </Row>
                        )
                    }

                    {
                        itemDetails?.location_id > 0 && (
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Text>Location Batches</Text>
                                    <Select
                                        placeholder="Location Batches"
                                        size="large"
                                        showSearch
                                        style={{ width: '100%' }}
                                        filterOption={(input, option) =>
                                            option?.label?.props?.children
                                                ?.map?.((el) => (typeof el === 'string' ? el : ''))
                                                .join(' ')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        value={itemDetails?.batch_id}
                                        onChange={(value) => {
                                            const selectedBatch = locationsBatches?.find((item) => item.batch_id === value);
                                            setItemDetails({
                                                ...itemDetails,
                                                batch_id: value,
                                                batch_expiry: selectedBatch?.expiry_date,
                                                batch_quantity: selectedBatch?.stock_level,
                                                batch_code: selectedBatch?.batch_code,
                                                supplier_batch_code: selectedBatch?.supplier_batch_code,
                                            });
                                        }}
                                        optionLabelProp="label"
                                    >
                                        {locationsBatches.map((item) => {
                                            const expiryDate = item?.expiry_date ? dayjs(item.expiry_date) : null;
                                            const daysToExpire = expiryDate ? expiryDate.diff(dayjs(), 'day') : null;

                                            const expiryColor =
                                                !expiryDate ? 'default' :
                                                    daysToExpire < 0 ? 'red' :
                                                        daysToExpire <= 30 ? 'orange' : 'green';

                                            const label = (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.stock_level}</Tag>
                                                    <Tag color={expiryColor} style={{ margin: 0 }}>
                                                        Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                                    </Tag>
                                                </div>
                                            );

                                            return (
                                                <Option key={item.batch_id} value={item.batch_id} label={label} style={{ padding: 0 }}>
                                                    <div
                                                        style={{
                                                            padding: '8px 12px',
                                                            margin: '4px 0',
                                                            border: '1px solid #f0f0f0',
                                                            borderRadius: '8px',
                                                            backgroundColor: '#fafafa',
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                                            <Tag color="blue" style={{ fontWeight: 'bold', marginRight: 4 }}>
                                                                Qty: {item?.stock_level}
                                                            </Tag>
                                                            <Tag color={expiryColor} style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                Exp: {expiryDate ? expiryDate.format('DD-MM-YYYY') : 'N/A'}
                                                            </Tag>
                                                        </div>
                                                        {item?.supplier_batch_code && (
                                                            <div style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center' }}>
                                                                Batch Code: <span style={{ fontWeight: 500, marginLeft: 4 }}>{item?.supplier_batch_code}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                </Col>
                            </Row>
                        )
                    }
                    {
                        itemDetails?.batch_id && (
                            <Row >
                                <Col>
                                    <Text>Quantity</Text>
                                    <InputNumber
                                        placeholder='Quantity'
                                        size='large'
                                        style={{ width: '100%' }}
                                        value={itemDetails.quantity}
                                        onChange={(value) => {
                                            const batch_quantity = itemDetails?.batch_quantity || 0
                                            if (value < -batch_quantity) {
                                            showMessage('error', `You cannot reduce more than available stock (${batch_quantity}).`);
                                            return;
                                            }
                                            setItemDetails({
                                                ...itemDetails,
                                                quantity: value
                                            })
                                        }}
                                    />

                                </Col>
                            </Row>
                        )
                    }
                </>
            </Modal>
        </DataSheet>
    );
};

export default InventoryAdjustment;
